import React from 'react';
import { MessageCircle } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';

const EventCommentsSection = ({ comments, user, newComment, setNewComment, onSubmit }) => (
  <div className="bg-white/50 backdrop-blur-sm border border-[#E5E5E5] rounded-lg p-6 space-y-6">
    <div className="flex items-center gap-2">
      <MessageCircle className="w-5 h-5 text-primary" />
      <h2 className="text-xl font-semibold text-[#0A0A0A]">Comentarios ({comments.length})</h2>
    </div>

    {user && (
      <form onSubmit={onSubmit} className="space-y-3">
        <Textarea
          placeholder="Agrega un comentario..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          className="bg-white border-[#E5E5E5] text-[#0A0A0A] focus:border-primary"
          rows={3}
          data-testid="comment-input"
        />
        <Button type="submit" size="sm" disabled={!newComment.trim()} data-testid="comment-submit-button">
          Comentar
        </Button>
      </form>
    )}

    <div className="space-y-4">
      {comments.map(comment => (
        <div key={comment.comment_id} className="flex gap-3 p-4 bg-white/50 rounded-lg" data-testid={`comment-${comment.comment_id}`}>
          <div className="flex-shrink-0">
            {comment.user_picture ? (
              <img src={comment.user_picture} alt={comment.user_name} className="w-10 h-10 rounded-full" />
            ) : (
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-semibold">
                {comment.user_name.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div className="flex-1">
            <p className="font-semibold text-[#0A0A0A] mb-1">{comment.user_name}</p>
            <p className="text-[#525252] text-sm">{comment.text}</p>
            <p className="text-xs text-[#737373] mt-2">
              {format(new Date(comment.created_at), "d 'de' MMMM, yyyy", { locale: es })}
            </p>
          </div>
        </div>
      ))}

      {comments.length === 0 && (
        <p className="text-center text-[#737373] py-8">No hay comentarios aún. ¡Sé el primero!</p>
      )}
    </div>
  </div>
);

export default EventCommentsSection;
